import React, { Component, PropTypes } from 'react';

import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import {GridList, GridTile} from 'material-ui/GridList';

import moment from 'moment';
import { FetchXHR } from '../../Helpers/generals';

import './Graphs.css';
import GraphsStyles from './GraphsStyles';

const defaultProps = {
    graphs: []
};

class Graphs extends Component {
    constructor(props) {
        super(props);

        this.graphsData = [
            {
                title: 'Visitas',
                subtitle: 'Numero de visitas al sitio.',
                key: 'visits',
                lineColor: '#03A9F4',
                dataKeyYAxis: 'value',
                dataKeyXAxis: 'label',
                width: 500,
                height: 300,
                data: [
                    {label: 'Page A', value: 4000},
                    {label: 'Page B', value: 3000},
                    {label: 'Page C', value: 2000},
                    {label: 'Page D', value: 2780},
                    {label: 'Page E', value: 1890},
                    {label: 'Page F', value: 2390},
                    {label: 'Page G', value: 3490},
                ]

            },
            {
                title: 'Visitas',
                subtitle: 'Numero de visitas al sitio.',
                key: 'shares',
                lineColor: '#03A9F4',
                dataKeyYAxis: 'value',
                dataKeyXAxis: 'label',
                width: 500,
                height: 300,
                data: [
                    {label: 'Page A', value: 4000},
                    {label: 'Page B', value: 3000},
                    {label: 'Page C', value: 2000},
                    {label: 'Page D', value: 2780},
                    {label: 'Page E', value: 1890},
                    {label: 'Page F', value: 2390},
                    {label: 'Page G', value: 3490},
                ]

            },
            {
                title: 'Visitas',
                subtitle: 'Numero de visitas al sitio.',
                key: 'shares',
                lineColor: '#03A9F4',
                dataKeyYAxis: 'value',
                dataKeyXAxis: 'label',
                width: 500,
                height: 300,
                data: [
                    {label: 'Page A', value: 4000},
                    {label: 'Page B', value: 3000},
                    {label: 'Page C', value: 2000},
                    {label: 'Page D', value: 2780},
                    {label: 'Page E', value: 1890},
                    {label: 'Page F', value: 2390},
                    {label: 'Page G', value: 3490},
                ]

            },
            {
                title: 'Visitas',
                subtitle: 'Numero de visitas al sitio.',
                key: 'shares',
                lineColor: '#03A9F4',
                dataKeyYAxis: 'value',
                dataKeyXAxis: 'label',
                width: 500,
                height: 300,
                data: [
                    {label: 'Page A', value: 4000},
                    {label: 'Page B', value: 3000},
                    {label: 'Page C', value: 2000},
                    {label: 'Page D', value: 2780},
                    {label: 'Page E', value: 1890},
                    {label: 'Page F', value: 2390},
                    {label: 'Page G', value: 3490},
                ]

            }
        ];
    }
    componentWillMount() {
        //FetchXHR('', method, data);
    }
    render() {
        const renderGraphs = this.props.graphs.map((g) => {
            return (
                <div style={{ padding: 20 }}>
                    <Card style={{ width: g.width + 30, paddingBottom: 20 }}>
                        <CardTitle title={g.title} subtitle={g.subtitle} />
                        <LineChart width={g.width} height={g.height} data={g.data}
                                    margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                            <XAxis dataKey={g.dataKeyXAxis}/>
                            <YAxis/>
                            <CartesianGrid strokeDasharray="3 3"/>
                            <Tooltip/>
                            <Legend />
                            <Line type="monotone" dataKey={g.dataKeyYAxis} stroke={g.lineColor} />
                        </LineChart>
                    </Card>

                </div>
            );
        });
        return (
            <div className="dashboard-graphs">
                {renderGraphs}
            </div>
        );
    }
}

Graphs.defaultProps = defaultProps;

export default Graphs;



// WEBPACK FOOTER //
// ./src/Components/Graphs/Graphs.jsx